import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Briefcase16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.6693 2.75L5.58333 0.656538C5.82014 0.397529 6.15492 0.25 6.50586 0.25H9.49376C9.84471 0.25 10.1795 0.39753 10.4163 0.656538L12.3303 2.75H14.5C15.1904 2.75 15.75 3.30964 15.75 4V13.5C15.75 14.1904 15.1904 14.75 14.5 14.75H1.5C0.809644 14.75 0.25 14.1904 0.25 13.5V4C0.25 3.30964 0.809643 2.75 1.5 2.75H3.6693ZM5.70175 2.75L6.61603 1.75H9.38359L10.2979 2.75H5.70175ZM1.75 8.26787C3.48656 9.12685 5.34988 9.62345 7.25 9.72878V11H8.75V9.72953C10.6503 9.6259 12.5139 9.12939 14.25 8.26915V13.25H1.75V8.26787ZM1.75 6.57073V4.25H14.25V6.57126C12.5289 7.5489 10.6572 8.11024 8.75 8.22703V7.5H7.25V8.22619C5.34304 8.10755 3.4717 7.54639 1.75 6.57073Z'
      fill='currentColor'
    />
  </Svg>
);

Briefcase16.displayName = 'Briefcase16';
export default Briefcase16;
